<!--下单-->
<template>
    <div style="height:100%;background:#f8f8f8;padding-bottom:5rem">
        <!-- 下单 -->
        <div class="check-header">
            <div class="business-shop-info">
                <div class="business-shop-box" style="display: flex;justify-content: flex-start;">
                    <img class="load-img"
                         v-if="row.status_icon"
                         style=" width: 1.2rem;
                            height: 1.2rem;
                            margin: 10px;"
                         :src="'https://static.dierqudao.com/images/icon-order-'+row.status_icon+'.png'"
                         alt="" >
                    <div class="shop-name">
                        <div style="font-size:19px">{{row.status_name}}</div>
                        <!--<div class="shop-phone" style="font-size:14px">{{row.phone}}</div>-->
                    </div>
                </div>
                <!--<div class="shop-address" >七彩星级报名信息</div>-->
                <div class="delivery-times"  >
                    <div class="timers-start">
                        <van-icon name="clock-o" /> 时间地点
                    </div>
                    <div class="timers-end">{{row.apply.province}}{{row.apply.city}}({{row.apply.datetitle}})</div>
                </div>
            </div>
        </div>

        <div style="height: 20px;"></div>

        <van-divider>考级信息</van-divider>

        <van-cell-group>
            <van-cell title="单位" :value="row.apply.danwei" />
            <van-cell title="地址" :value="row.apply.address" />
        </van-cell-group>

        <van-divider >运动员信息</van-divider>

            <van-cell-group>

                <van-field
                        v-model="row.name"
                        readony
                        label="姓名"
                        input-align="right"
                />

                <van-field
                        v-model="row.num"
                        readony
                        label="身份证"
                        input-align="right"
                />
                <van-field
                        v-model="row.grade"
                        readony
                        label="报考星级"
                        input-align="right"
                />


            </van-cell-group>

        <van-divider >费用信息</van-divider>

            <van-cell-group>

                <van-field
                        v-model="row.a_price"
                        readony
                        label="考级费"
                        input-align="right"
                />

                <van-field
                        v-model="row.c_price"
                        readony
                        label="考级服费"
                        input-align="right"
                />
                <van-field
                        v-model="row.s_price"
                        readony
                        label="考级鞋费"
                        input-align="right"
                />
                <van-field
                        v-model="row.price"
                        readony
                        label="总计"
                        input-align="right"
                />


            </van-cell-group>

            <div class="savebtn">
                <van-button
                        v-if="row.status_icon=='pay'"
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        @click="onSubmit"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."  >支付费用</van-button>
            </div>


        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />

        <PayDialog :show="payDialogShow" scene="qcxj_member_apply" :ids="orderIds" @onPayError="onPayError" @onPaySuccess="onPaySuccess"
                   @onPayClose="onPayClose"/>

    </div>
</template>
<style scoped>

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }

    .shop-name {
        display: flex;
        justify-content: space-between;
        font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        line-height: 27px;
        margin-top: 0.4rem;
        padding: 0 0.3rem;
    }
    .shop-address {
        height: 13px;
        font-size: 9px;
        
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 13px;
        margin-top: 0.1rem;
        padding: .2rem .3rem .4rem;
        border-bottom: 1px solid rgba(0,0,0,.1);
    }
    .delivery-times {
        margin-top: 0.2rem;
        padding: 0 0.3rem;
        display: flex;
        justify-content: space-between;
    }
    .business-shop-info {
        width: 6.81rem;
        height: 2.66rem;
        border-radius: 7px;
        margin-bottom: 0;
        display: flex;
        flex-flow: column;
        position: absolute;
        bottom: -0.4rem;
        left: 0;
        right: 0;
        margin: auto;
        background: #fff
        6.5rem center;
        background-size: 10px;
    }
    .check-header {
        width: 100%;
        height: 4rem;
        background: url(../../../assets/images/bg-qcxj-index.png)
        no-repeat center;
        background-size: 100%;
        position: relative;
    }

</style>

<script>
    import { Field, Notify, Toast, Popup, Picker,Radio,RadioGroup,Dialog ,ImagePreview} from "vant";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import LoginDialog from '@/components/LoginDialog.vue';
    import PayDialog from '@/components/PayDialog.vue';


    export default {
        name: "ExameApplJoin",
        components: {
            [Field.name]: Field,
            Notify,
            Dialog,
            Radio,
            RadioGroup,
            Popup,
            PicUploader,
            [ImagePreview.Component.name]: ImagePreview.Component,
            Toast,
            Picker,
            PayDialog,
            LoginDialog
        },
        data: function() {
            return {
                validator,
                isSubmit:false,
                loginShow:false,
                payDialogShow:false,
                cSizeShow:false,
                fSizeShow:false,
                confirmShow:false,
                kaoji_id: this.$route.query.kaoji_id,
                share_id: this.$route.query.share_id,
                gradeColumns:['红','橙','黄','绿','青','蓝','紫'],
                cSizePicList:['https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/7fd2e382afe6f9bd49b3ce9a8ae37a24.png','https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/8fb609af0a199bea84da2ff641aacf1f.png'],
                fSizePicList:['https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/33e31ebf9997638013aacb02ed5eeb41.png'],
                showGradePicker:false,
                showNumTypePicker:false,
                message: "",
                formData: {
                    needLoadingIndicator: true,
                    gradeindex:0,
                    grade:'',
                    csize:'',
                    numTypeName:'身份证',
                    numtype:1,
                    kaoji_id: this.$route.query.kaoji_id,
                    share_id: this.$route.query.share_id,
                    name:'',
//                    num:'362323198807150036',
//                    pic:[{"uid":"vc-upload-1588058680174338","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-28/1588058680174338.png","name":" bg-doing.png","save_name":"h5/2020-04-28/1588058680174338.png"}],
                    pic:[],
//                    height:1,
//                    weight:2,
//                    footsize:3,
//                    famliy_name:'李',
//                    famliy_num:'320101197301011111',
//                    phone:'15177772222',
                },
                numTypeColumns: ['身份证', '护照'],
                row:{
                    apply:{

                    }
                },
                warnings: [],
                saveLoading:false,

            };
        },
        watch: {
        },

        filter: {},
        mounted() {
            document.title = "参加邀请";
            this.fetch();
        },
        destroyed() {},
        methods: {
            fetch(){
                let that = this;
                that.$api.get('/api/qcxj/kaojiJoinMemberDetail', {
                    id:that.$route.query.id,
                }, (res) => {
                    that.row = res.data;
                }, (res) => {
                    if (res.code == 401 || res.code==402) {
                        if(window.isApp()){
                            rbLink({
                                name:'login','query':{ }
                            },'replace');
                            return false;
                        }
                        that.loginShow = true
                    }else {
                        Toast(res.msg)
                    }
                })
            },


            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                }
                that.saveLoading = true;

                that.$api.post('/api/qcxj/applyMemberOrderSave', that.row, (res) => {
                    that.saveLoading = false;

                    that.orderIds = res.data.ids;
                    that.payDialogShow = true;

                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },

            loginSuccess(res){
                console.log('-------登录成功--------',res);
                this.loginShow = false;
                this.fetch();
            },

            loginCancel(){
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },
        }
    };
</script>



// WEBPACK FOOTER //
// ExameApplyJoinDetail.vue?ebfc4948